module.exports = __webpack_public_path__ + "img/hr-rail-chain-signal.b80e132c.png";